<template>
  <div class="facility-area-box">
    <span class="box-title">避難元医療機関等施設</span>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0 shelter-table"
      locale="ja-jp"
      hide-default-footer
      hide-default-header
      item-key="key"
      no-data-text=""
      :items-per-page="500"
    >
      <template v-slot:[`item.vul_origin_municip_code`]="{ item }">
        <v-select
          :items="municipalities"
          v-model="item.vul_origin_municip_code"
          v-bind="$formControlProps(readOnly)"
          label="避難元市町村"
          :placeholder="config.PLACEHOLDER_SELECT"
          @change="changeMunicipality(item)"
        ></v-select>
      </template>
      <template v-slot:[`item.vul_origin_fa_id`]="{ item }">
        <v-select
          :items="vulFacilityForEdit[item.key]"
          v-model="item.vul_origin_fa_id"
          v-bind="$formControlProps(readOnly)"
          label="施設名"
          :placeholder="config.PLACEHOLDER_SELECT"
          :error-messages="errorArea(item)"
          item-text="fa_name"
          item-value="fa_id"
        ></v-select>
      </template>
      <template v-slot:[`item.actions`]>
        <v-btn class="mx-2" color="primary" v-if="!readOnly" @click="addItem"
          >追加</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import maxBy from "lodash/maxBy";
import config from "@/js/const";

export default {
  name: "VulFacilityInfo",
  data: () => ({
    config: config,
    items: [],
    vulFacilityForEdit: []
  }),
  props: {
    //親から受け取るデータ
    vulFacilityInfo: {
      type: Array,
      default: () => []
    },
    editedVulFacilityInfo: {
      type: Array,
      default: () => []
    },
    municipalities: {
      type: Array,
      default: () => []
    },
    facilities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean
    },
    faId: {
      type: String
    }
  },
  watch: {
    items: {
      handler: function(newItems) {
        this.$emit("update:editedVulFacilityInfo", newItems);
      },
      deep: true
    },
    faId: "initialize"
  },
  mounted() {
    this.initialize();
  },
  computed: {
    headers() {
      return [
        {
          text: "避難元市町村",
          value: "vul_origin_municip_code",
          sortable: false
        },
        {
          text: "施設名",
          value: "vul_origin_fa_id",
          sortable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  methods: {
    initialize() {
      if (this.editedVulFacilityInfo.length == 0) {
        this.items = cloneDeep(this.vulFacilityInfo);
      } else {
        this.items = cloneDeep(this.editedVulFacilityInfo);
      }
      // keyが存在しない場合は追加
      this.items.forEach((item, index) => {
        if (!item.key) {
          item.key = index + 1;
        }
      });
      this.items.forEach(item => {
        this.changeMunicipality(item, false);
      });
    },
    addItem() {
      const maxItem = maxBy(this.items, "key");
      this.items.push({
        key: maxItem.key + 1,
        vul_origin_municip_code: "",
        vul_origin_fa_id: ""
      });
    },
    // 市町村が変更されたとき
    changeMunicipality(item) {
      //施設名リストボックス設定
      if (this.facilities.length > 0) {
        //選択市町村・施設名のみに絞込み
        this.vulFacilityForEdit[item.key] = this.facilities.filter(
          facility => facility.municip_code === item.vul_origin_municip_code
        );
      }
    },
    errorArea(item, items = this.items) {
      // 施設名の重複チェック
      if (!item.vul_origin_fa_id) {
        return "";
      }
      const hasItem = items.some(data => {
        return (
          item.key !== data.key &&
          item.vul_origin_fa_id === data.vul_origin_fa_id
        );
      });
      if (hasItem) {
        return "重複しています。";
      }
      return "";
    },
    validate() {
      let validate = true;
      this.editedVulFacilityInfo.forEach(item => {
        if (this.errorArea(item, this.editedVulFacilityInfo) !== "") {
          validate = false;
          return false;
        }
      });
      return validate === true;
    }
  }
};
</script>
